import React, { type ReactNode, useRef } from 'react';

interface FileUploadProps {
  onClick?: () => void;
  onFileChange?: (file?: File) => void;
  accept?: string;
  children?: ReactNode;
}

const FileUpload: React.FC<FileUploadProps> = ({ onClick, onFileChange, accept, children }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    if (fileInputRef.current) fileInputRef.current.click();
    if (onClick) onClick();
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (onFileChange) onFileChange(file);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  return (
    <div>
      <div onClick={handleClick}>
        {children}
      </div>
      <input
        type="file"
        style={{ display: 'none' }}
        ref={fileInputRef}
        accept={accept}
        onChange={handleChange}
      />
    </div>
  );
};

export default FileUpload;
